import { render, staticRenderFns } from "./CheckboxButtonBuilder.vue?vue&type=template&id=fabe50ee&scoped=true"
import script from "./CheckboxButtonBuilder.vue?vue&type=script&lang=js"
export * from "./CheckboxButtonBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabe50ee",
  null
  
)

export default component.exports